import React from 'react';
import tw from 'twin.macro';
import { useTableContext } from './index';

interface Props {
  children?: React.ReactNode;
  className?: string;
}

export default function Th(props: Props) {
  const { children, className, ...rest } = props;
  const { condensed } = useTableContext();

  return (
    <th
      className={className}
      css={[
        tw`text-left font-medium text-neutral-quiet uppercase tracking-wider`,
        condensed ? tw`px-3 py-2 text-xs` : tw`px-6 py-3 text-xs`,
      ]}
      {...rest}
    >
      {children}
    </th>
  );
}
